import { render, staticRenderFns } from "./estimateInfo.vue?vue&type=template&id=7e51cedd&scoped=true"
import script from "./estimateInfo.vue?vue&type=script&lang=js"
export * from "./estimateInfo.vue?vue&type=script&lang=js"
import style0 from "./estimateInfo.vue?vue&type=style&index=0&id=7e51cedd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e51cedd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e51cedd')) {
      api.createRecord('7e51cedd', component.options)
    } else {
      api.reload('7e51cedd', component.options)
    }
    module.hot.accept("./estimateInfo.vue?vue&type=template&id=7e51cedd&scoped=true", function () {
      api.rerender('7e51cedd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/goodsManage/estimateInfo.vue"
export default component.exports